import styled from 'styled-components'
import { Segment } from 'semantic-ui-react'

import FlexRow from '../FlexRow'

interface ClickableRowProps {
  noMargin?: boolean
  onClick: () => void
}

export const StyledSegmentGroup = styled(Segment.Group)`
  &&&& {
    border: 1px solid #dbe2e4;

    .segment {
      box-shadow: none;
    }

    .segment:not(:last-child) {
      border-bottom: 1px solid #d8dadb;
    }
  }
`

export const SegmentWrapper = styled(Segment)`
  &&& {
    border: 1px solid #dbe2e4;
    box-shadow: none;

    ${props =>
      props.basic &&
      `
      border: none;
      background: none;
      padding: 0;
      margin-top: 1em;
    `};

    ${props => props.noMargin && 'margin: 0 !important'};

    ${props =>
      props.disabled &&
      `
      opacity: 0.6 !important;
      color: inherit !important;
    `}
  }
`

// @ts-ignore
export const ClickableRow = styled(FlexRow).attrs({
  noMargin: true,
})<ClickableRowProps>`
  &,
  & > i {
    cursor: pointer;
  }
`
